/* jscs:disable disallowArrayDestructuringReturn */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SelfPayRow from './SelfPayRow';
import { genCashPrices } from './util';
import { colors } from '../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../constants/text';
import { isEmptyArray } from '../../../../core/util/array';
import { biggerThanOrEqualTo } from '../../../../core/util/styledComponents';
import PanelCard from '../../PanelCards/components/PanelCard';
import { SELF_PAY_PRICES, shouldShowFeature } from '../../util/customization';
import { formatPrice } from '../../../../core/util/string';

const HIGHLIGHTED_SERVICE = 'Base Price';

const Root = styled.div`
  -webkit-font-smoothing: antialiased;
  width: 100%;
`;

const ServiceContainer = styled.div`
  display: inline-block;
  width: 100%;

  ${biggerThanOrEqualTo.md`
    padding-left: 25px;
    max-width: 400px;
  `}
`;

const ServiceIcon = styled.img`
  width: 15px;
  height: 15px;
  padding-right: 10px;
  display: inline-block;
  vertical-align: middle;
`;

const Copy = styled.div`
  color: ${colors.blueMonday};
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.book};
  padding: 0 0 30px;
`;

const Title = styled.h2`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.default};
  color: ${colors.squid};
  margin-top: 0;
  display: inline-block;
`;

const List = styled.ol`
  list-style: none;
  padding: 0;
  flex-grow: 1;
`;

const Disclaimer = styled.div`
  font-size: ${fontSize.small};
  font-family: ${fontFamily.book};
  color: ${colors.lanaDelGrey};
`;

export default class SelfPay extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    className: PropTypes.string,
    enableCollapsing: PropTypes.bool,
    defaultExpanded: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    const { location } = props;
    this.services = genCashPrices(location.servicePrices, HIGHLIGHTED_SERVICE);
    const prices = this.services.map(service => service.price);
    this.maxPrice = Math.max(...prices);
    this.minPrice = Math.min(...prices);
    if (!isEmptyArray(this.services)) {
      const filtered = this.services.filter(service => service.name === HIGHLIGHTED_SERVICE);
      if (filtered.length > 0 && filtered[0].price) {
        const { price } = filtered[0];
        this.basePrice = price;
      }
    }
  }

  shouldRender = () =>
    shouldShowFeature(SELF_PAY_PRICES, this.props.location) && !isEmptyArray(this.services);

  render() {
    if (!this.shouldRender()) return null;
    const {
      location: { displayNamePrimary },
      className,
      enableCollapsing,
      defaultExpanded,
    } = this.props;
    return (
      <PanelCard title="Self-Pay Prices" {...{ enableCollapsing, defaultExpanded }}>
        <Root className={className}>
          <Copy>
            The base price for an office visit at {displayNamePrimary} is{' '}
            {formatPrice(this.basePrice)} with additional services being an extra charge. Patients
            typically pay between {formatPrice(this.minPrice)} - {formatPrice(this.maxPrice)} for
            common services.
          </Copy>
          <div>
            <ServiceIcon src="/images/icons/Icon-Services.svg" alt="Services icon" />
            <Title>Common Services</Title>
          </div>
          <ServiceContainer>
            <List>
              {this.services.map((service, i) => (
                <SelfPayRow key={i} {...service} />
              ))}
            </List>
            <Disclaimer>NOTE: Prices quoted are cash prices for uninsured patients</Disclaimer>
          </ServiceContainer>
        </Root>
      </PanelCard>
    );
  }
}
